"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.MerchantChannelCollectionBuilder = exports.MerchantChannelPieceVariantBuilder = exports.MerchantChannelAccessoryVariantBuilder = exports.MerchantChannelProductBuilder = exports.MerchantChannelCollection = void 0;
var core_designer_domain_1 = require("@jewelutions/core-designer-domain");
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var MerchantChannelCollection = /** @class */ (function () {
    function MerchantChannelCollection() {
    }
    MerchantChannelCollection.getMerchantChannelPieceVariant = function (originalCollection, merchantChannelProductId, merchantChannelPieceVariantId) {
        var originalProduct = originalCollection.products.find(function (product) { return product.id === merchantChannelProductId; });
        if (originalProduct === undefined) {
            throw new core_common_domain_1.Exception("Cannot locate merchant channel product " + merchantChannelProductId + " in collection " + originalCollection.id);
        }
        return originalProduct.pieceVariants.find(function (pieceVariant) { return pieceVariant.id === merchantChannelPieceVariantId; });
    };
    return MerchantChannelCollection;
}());
exports.MerchantChannelCollection = MerchantChannelCollection;
var MerchantChannelProductBuilder = /** @class */ (function () {
    function MerchantChannelProductBuilder(product) {
        this.product = product;
    }
    MerchantChannelProductBuilder.initialise = function (id, productIdentity, title, description, geometryType) {
        return new MerchantChannelProductBuilder({
            id: id,
            productIdentity: productIdentity,
            title: title,
            description: description,
            geometryType: geometryType,
            pieceVariants: [],
            accessoryVariants: []
        });
    };
    MerchantChannelProductBuilder.prototype.getId = function () {
        return this.product.id;
    };
    MerchantChannelProductBuilder.prototype.addPieceVariant = function (pieceVariant) {
        this.product.pieceVariants.push(pieceVariant);
        return this;
    };
    MerchantChannelProductBuilder.prototype.addAccessoryVariant = function (accessoryVariant) {
        this.product.accessoryVariants.push(accessoryVariant);
        return this;
    };
    MerchantChannelProductBuilder.prototype.build = function () {
        return this.product;
    };
    return MerchantChannelProductBuilder;
}());
exports.MerchantChannelProductBuilder = MerchantChannelProductBuilder;
var MerchantChannelAccessoryVariantBuilder = /** @class */ (function () {
    function MerchantChannelAccessoryVariantBuilder(merchantChannelAccessoryVariant) {
        this.variant = merchantChannelAccessoryVariant;
    }
    MerchantChannelAccessoryVariantBuilder.initialise = function (accessoryReference, acquisitionPrice, retailPrice, weightInGrams) {
        return new MerchantChannelAccessoryVariantBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            image: core_common_domain_1.Image.UNDEFINED,
            accessoryReference: accessoryReference,
            acquisitionPrice: acquisitionPrice,
            retailPrice: retailPrice,
            weightInGrams: weightInGrams
        });
    };
    MerchantChannelAccessoryVariantBuilder.prototype.getId = function () {
        return this.variant.id;
    };
    MerchantChannelAccessoryVariantBuilder.prototype.build = function () {
        return this.variant;
    };
    return MerchantChannelAccessoryVariantBuilder;
}());
exports.MerchantChannelAccessoryVariantBuilder = MerchantChannelAccessoryVariantBuilder;
var MerchantChannelPieceVariantBuilder = /** @class */ (function () {
    function MerchantChannelPieceVariantBuilder(variant) {
        this.variant = variant;
    }
    MerchantChannelPieceVariantBuilder.initialise = function (image, pieceReference, engravings, acquisitionPrice, retailPrice, weightInGrams) {
        return new MerchantChannelPieceVariantBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            image: image,
            pieceReference: pieceReference,
            engravings: engravings,
            acquisitionPrice: acquisitionPrice,
            retailPrice: retailPrice,
            weightInGrams: weightInGrams
        });
    };
    MerchantChannelPieceVariantBuilder.prototype.getId = function () {
        return this.variant.id;
    };
    MerchantChannelPieceVariantBuilder.prototype.build = function () {
        return this.variant;
    };
    return MerchantChannelPieceVariantBuilder;
}());
exports.MerchantChannelPieceVariantBuilder = MerchantChannelPieceVariantBuilder;
var MerchantChannelCollectionBuilder = /** @class */ (function () {
    function MerchantChannelCollectionBuilder(originalCollection) {
        this.collection = originalCollection;
    }
    MerchantChannelCollectionBuilder.initialiseWithCollection = function (collection) {
        return new MerchantChannelCollectionBuilder(collection);
    };
    MerchantChannelCollectionBuilder.prototype.build = function () {
        return this.collection;
    };
    MerchantChannelCollectionBuilder.prototype.addDesignerFeatureIfMissing = function (designerFeature) {
        if (this.collection.availableDesignerFeatures.find(function (f) { return f.type === designerFeature.type; }) === undefined) {
            this.collection.availableDesignerFeatures.push(designerFeature);
        }
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addSymbolCollectionIfMissing = function (addedSymbolCollectionId) {
        var updatedCollection = __assign(__assign({}, this.collection), { availableSymbolCollectionIds: Array.from(new Set(this.collection.availableSymbolCollectionIds).add(addedSymbolCollectionId)) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.deleteSymbolCollectionIfPresent = function (removedSymbolCollectionId) {
        var updatedCollection = __assign(__assign({}, this.collection), { availableSymbolCollectionIds: this.collection.availableSymbolCollectionIds.filter(function (scId) { return scId !== removedSymbolCollectionId; }) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addFontIfMissing = function (addedFontId) {
        var updatedCollection = __assign(__assign({}, this.collection), { availableFontIds: Array.from(new Set(this.collection.availableFontIds).add(addedFontId)) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.deleteFontIfPresent = function (removedFontId) {
        var updatedCollection = __assign(__assign({}, this.collection), { availableFontIds: this.collection.availableFontIds.filter(function (fontId) { return fontId !== removedFontId; }) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addPieceIfMissing = function (addedPiece) {
        /* Add the piece configs */
        var updatedCollection = __assign(__assign({}, this.collection), { availablePieceIds: Array.from(new Set(this.collection.availablePieceIds).add(addedPiece.id)) });
        this.collection = updatedCollection;
        /* Add the piece configs */
        this.addPieceConfigurationsIfMissing(core_designer_domain_1.Piece.getAllAvailablePieceConfigurations(addedPiece));
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.deletePieceIfPresent = function (removedPiece) {
        var updatedCollection = __assign(__assign({}, this.collection), { availablePieceIds: this.collection.availablePieceIds.filter(function (pieceId) { return pieceId !== removedPiece.id; }) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addAccessoryIfMissing = function (addedAccessory) {
        /* Add the accessory id */
        var updatedCollection = __assign(__assign({}, this.collection), { availableAccessoryIds: Array.from(new Set(this.collection.availableAccessoryIds).add(addedAccessory.id)) });
        this.collection = updatedCollection;
        /* Add the accessory configs */
        this.addAccessoryConfigurationsIfMissing(core_designer_domain_1.Accessory.getAllAvailableAccessoryConfigurations(addedAccessory));
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.deleteAccessoryIfPresent = function (removedAccessory) {
        var updatedCollection = __assign(__assign({}, this.collection), { availableAccessoryIds: this.collection.availableAccessoryIds.filter(function (accessoryId) { return accessoryId !== removedAccessory.id; }) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addAccessoryConfigurationsIfMissing = function (addedAccessoryConfigurations) {
        var updatedAvailableAccessoryConfigurations = this.collection
            .availableAccessoryConfigurations;
        var _loop_1 = function (addedAccessoryConfiguration) {
            /* if missing then add it */
            if (!updatedAvailableAccessoryConfigurations.find(function (ac) {
                return core_designer_domain_1.AccessoryConfiguration.identical(addedAccessoryConfiguration, ac);
            })) {
                updatedAvailableAccessoryConfigurations.push(addedAccessoryConfiguration);
            }
        };
        for (var _i = 0, addedAccessoryConfigurations_1 = addedAccessoryConfigurations; _i < addedAccessoryConfigurations_1.length; _i++) {
            var addedAccessoryConfiguration = addedAccessoryConfigurations_1[_i];
            _loop_1(addedAccessoryConfiguration);
        }
        var updatedCollection = __assign(__assign({}, this.collection), { availableAccessoryConfigurations: updatedAvailableAccessoryConfigurations });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addPieceConfigurationsIfMissing = function (addedPieceConfigurations) {
        var updatedAvailablePieceConfigurations = this.collection
            .availablePieceConfigurations;
        var _loop_2 = function (addedPieceConfiguration) {
            /* if missing then add it */
            if (!updatedAvailablePieceConfigurations.find(function (ac) {
                return core_designer_domain_1.PieceConfiguration.identical(addedPieceConfiguration, ac);
            })) {
                updatedAvailablePieceConfigurations.push(addedPieceConfiguration);
            }
        };
        for (var _i = 0, addedPieceConfigurations_1 = addedPieceConfigurations; _i < addedPieceConfigurations_1.length; _i++) {
            var addedPieceConfiguration = addedPieceConfigurations_1[_i];
            _loop_2(addedPieceConfiguration);
        }
        var updatedCollection = __assign(__assign({}, this.collection), { availablePieceConfigurations: updatedAvailablePieceConfigurations });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.getMerchantChannelPieceVariant = function (merchantChannelProductId, merchantChannelPieceVariantId) {
        return MerchantChannelCollection.getMerchantChannelPieceVariant(this.collection, merchantChannelProductId, merchantChannelPieceVariantId);
    };
    MerchantChannelCollectionBuilder.prototype.updateMerchantChannelPieceVariant = function (merchantChannelProductId, merchantChannelPieceVariantId, update) {
        var originalProduct = this.collection.products.find(function (product) { return product.id === merchantChannelProductId; });
        if (originalProduct === undefined) {
            throw new core_common_domain_1.Exception("Cannot locate merchant channel product " + merchantChannelProductId + " in collection " + this.collection.id);
        }
        var originalPieceVariant = originalProduct.pieceVariants.find(function (pieceVariant) { return pieceVariant.id === merchantChannelPieceVariantId; });
        if (originalPieceVariant === undefined) {
            throw new core_common_domain_1.Exception("Cannot locate piece variant " + merchantChannelPieceVariantId + " in merchant channel product " + merchantChannelProductId + " of collection " + this.collection.id);
        }
        var updatedPieceVariant = __assign(__assign({}, originalPieceVariant), update);
        var updatedProduct = __assign(__assign({}, originalProduct), { pieceVariants: originalProduct.pieceVariants.map(function (pieceVariant) {
                return pieceVariant.id === merchantChannelPieceVariantId ? updatedPieceVariant : pieceVariant;
            }) });
        var updatedCollection = __assign(__assign({}, this.collection), { products: this.collection.products.map(function (product) {
                return product.id === merchantChannelProductId ? updatedProduct : product;
            }) });
        this.collection = updatedCollection;
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.productExists = function (productId) {
        return this.collection.products.find(function (p) { return p.id === productId; }) !== undefined;
    };
    MerchantChannelCollectionBuilder.prototype.clearAllProducts = function () {
        this.collection.products = [];
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addProducts = function (products) {
        for (var _i = 0, products_1 = products; _i < products_1.length; _i++) {
            var product = products_1[_i];
            this.addProduct(product);
        }
        return this;
    };
    MerchantChannelCollectionBuilder.prototype.addProduct = function (product) {
        if (this.productExists(product.id))
            throw new core_common_domain_1.Exception("Cannot add a duplicate product with id " + product.id + " in collection ");
        this.collection.products.push(product);
        return this;
    };
    return MerchantChannelCollectionBuilder;
}());
exports.MerchantChannelCollectionBuilder = MerchantChannelCollectionBuilder;
